import React, {FunctionComponent, useRef, useState} from "react";
import WizardStep from "../../WizardStep";
import statusContact from "../../../../images/Progress/kontakt_icn.svg";
import {Box, FormControl, Grid, InputLabel, makeStyles, NativeSelect} from "@material-ui/core";
import CommonTextInput from "../../../../commonComponents/ValidateTextInput";
import {ValidatorForm} from "react-material-ui-form-validator";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../redux/rootReducer";
import {
    setName,
    setLastName,
    setStreet,
    setPostalCode,
    setCity,
    setEmail,
    setPhone,
    setBirthday,
    setCountry
} from "../../../state/contactSlice";
import {Step} from "../../../WizardMap";
// @ts-ignore
import MuiPhoneNumber from "material-ui-phone-number";

import NotificationSettings from "./NotificationSettings";
import {removeCurrentDisposal} from "../../../state/disposalSlice";
import moment, {Moment} from "moment";
import DatePicker from "../../../../commonComponents/DatePicker";
import {NavigationProps} from "../../../slideRouter/navigationHook";
import {selectOptions} from "./SelectOptions";

export const longInputWith: number = 260;

const useStyles = makeStyles(theme => ({
    formContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    gridContainer: {
        marginBottom: 10
    },
    shortTextInput: {
        width: (longInputWith / 2) - 10
    },
    longTextInput: {
        width: longInputWith
    },
    longWithContainer: {
        width: longInputWith,
        display: "flex",
        justifyContent: "space-between"
    },
    notificationContainer: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        margin: "20px 0 40px 0 ",
        [theme.breakpoints.down("xs")]: {
            width: longInputWith,
            marginTop: 20
        }
    },
    phoneInput: {
        width: longInputWith,
        display: "flex",
        justifyContent: "space-between",
        padding: 0,
        margin: 0
    },
    inputLabel: {
        color: "#999"
    },
    phoneDropDown: {
        padding: 0,
        margin: 0,
        borderRadius: 5,
        color: "#000"
    }
}));

const StepContactData: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const formRef = useRef<ValidatorForm | null>(null);

    const [isUnder18, setIsUnder18] = useState<boolean>(false);
    const [phoneError, setPhoneError] = useState<boolean>(false);

    const {
        address,
        email,
        birthday,
        notificationType,
        phone
    } = useSelector((state: RootState) => state.contact);

    const onChangeBirthday = (birthday: Moment) => {
        if (moment().diff(birthday, "years", true) < 18) {
            setIsUnder18(true);
        } else {
            setIsUnder18(false);
        }
        dispatch(setBirthday(birthday ? birthday.toObject() : undefined));
    };

    const handleFormSubmit = (): void => {
        if (formRef.current) {
            formRef.current.isFormValid(false).then(isValid => {
                if (!birthday) {
                    setIsUnder18(true);
                }
                phone.length > 3 ? setPhoneError(false) : setPhoneError(true);
                birthday && !isUnder18 && phone.length > 3 && isValid && gotoNextSlide(Step.SHIPPING_TYPE);
            });
        }
    };

    const handleBackClicked = (): void => {
        dispatch(removeCurrentDisposal());
        gotoPrevSlide();
    };

    return (
        <WizardStep
            title={"Bitte geben Sie Ihre Kontaktdaten an"}
            icon={statusContact}
            backButton
            onBackClick={handleBackClicked}
            nextButton
            onNextClick={handleFormSubmit}
        >
            <ValidatorForm
                ref={formRef}
                onSubmit={() => {
                }}
                className={classes.formContainer}
                instantValidate={false}
            >
                <Grid
                    container
                    spacing={4}
                    justify={"center"}
                    className={classes.gridContainer}
                >
                    <Grid item>
                        <CommonTextInput
                            name="name"
                            label="Vorname"
                            validators={["required"]}
                            errorMessages={["erforderlich"]}
                            value={address.name}
                            onChangeText={(val: string) => dispatch(setName(val))}
                            className={classes.longTextInput}
                        />
                    </Grid>
                    <Grid item>
                        <CommonTextInput
                            name="lastName"
                            label="Nachname"
                            validators={["required"]}
                            errorMessages={["erforderlich"]}
                            value={address.lastName}
                            onChangeText={(val: string) => dispatch(setLastName(val))}
                            className={classes.longTextInput}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    spacing={4}
                    justify={"center"}
                    className={classes.gridContainer}
                >
                    <Grid item>
                        <CommonTextInput
                            name={"streetAndNumber"}
                            label={"Straße & Hausnummer"}
                            validators={["required"]}
                            errorMessages={["erforderlich"]}
                            value={address.street}
                            onChangeText={(val: string) => dispatch(setStreet(val))}
                            className={classes.longTextInput}
                        />
                    </Grid>
                    <Grid item>
                        <Box className={classes.longWithContainer}>
                            <CommonTextInput
                                name={"zipCode"}
                                label={"PLZ"}
                                validators={["required", "isNumber"]}
                                errorMessages={["erforderlich", "ungültig"]}
                                value={address.postalCode}
                                onChangeText={(val: string) => dispatch(setPostalCode(val))}
                                className={classes.shortTextInput}
                            />
                            <CommonTextInput
                                name={"city"}
                                label={"Stadt"}
                                validators={["required"]}
                                errorMessages={["erforderlich"]}
                                value={address.city}
                                onChangeText={(text: string) => dispatch(setCity(text))}
                                className={classes.shortTextInput}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Grid
                    container
                    spacing={4}
                    justify={"center"}
                    className={classes.gridContainer}
                >
                    <Grid item>
                        <FormControl className={classes.longWithContainer}>
                            <InputLabel htmlFor="country" style={{color: "#999"}}>Land</InputLabel>
                            <NativeSelect
                                value={address.country}
                                style={{color: "#000"}}
                                inputProps={{
                                    name: "country",
                                    id: "country"
                                }}
                                onChange={({target}) => {
                                    dispatch(setCountry(target.value));
                                }}
                            >
                                {selectOptions.country}
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <MuiPhoneNumber
                            label={"Telefon"}
                            value={phone}
                            InputLabelProps={{className: classes.inputLabel}}
                            InputProps={{style: {color: "#000"}}}
                            inputClass={classes.phoneInput}
                            dropdownClass={classes.phoneDropDown}
                            defaultCountry={"de"}
                            error={phoneError}
                            helperText={phoneError ? "erforderlich" : undefined}
                            // onlyCountries={["de", "ch", "at"]}
                            regions={["european-union"]}
                            localization={{"Germany": "Deutschland", "Austria": "Österreich", "Switzerland": "Schweiz"}}
                            countryCodeEditable={false}
                            onChange={(val: string) => dispatch(setPhone(val))}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    spacing={4}
                    justify={"center"}
                    className={classes.gridContainer}
                >
                    <Grid item>
                        <CommonTextInput
                            name="email"
                            label="E-Mail"
                            validators={["required", "isEmail"]}
                            errorMessages={["erforderlich", "invalid email"]}
                            value={email}
                            onChangeText={(text: string) => dispatch(setEmail(text))}
                            className={classes.longTextInput}
                        />
                    </Grid>
                    <Grid item>
                        <DatePicker
                            label={"Geburtstag"}
                            value={birthday ? moment(birthday) : null}
                            onSelectDate={(date: Moment | null) => onChangeBirthday(date as Moment)}
                            inputStyle={{width: longInputWith}}
                            error={isUnder18}
                            errorText={isUnder18 ? "Nicht 18" : ""}
                            disableFuture
                            openTo={"year"}
                            views={["year", "month", "date"]}
                            autoOk
                        />
                    </Grid>
                </Grid>
            </ValidatorForm>
            <NotificationSettings notificationType={notificationType} className={classes.notificationContainer}/>
        </WizardStep>
    );
};

export default StepContactData;
